module.exports = __webpack_public_path__ + "img/icon_cat_general.4bdb80c.png";